import "./App.css";
import React, { Fragment } from "react";
import Routes from "../src/Routes.jsx"

function App() {
  return (
    <div>
      <Routes/>
    </div>
  );
}
export default App;